import { Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Button,  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, IconButton, MenuItem } from "@mui/material";
import axios from "axios";
import { useState, Fragment } from "react";
import { toastMessage } from "../../utils/toastMessage";
import { put, get } from "../../config/axios";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export function EditableMealPlanTable({ dayPlan, planId, onUpdate }) {
  const [editablePlan, setEditablePlan] = useState(dayPlan);
  const [loading, setLoading] = useState(false);
  const [selectedFood, setSelectedFood] = useState(null);
const [selectedMealIdx, setSelectedMealIdx] = useState(null);
const [selectedFoodIdx, setSelectedFoodIdx] = useState(null);

const fetchAlternatives = async (mealType, coreCategory) => {
  try {
    const response = await get("/api/app/diet/alternatives", {
      mealType,
      coreCategory,
    });

    return response?.foods || [];
  } catch (err) {
    toastMessage("Failed to fetch alternatives", "error");
    return [];
  }
};

  const handleChange = (mealIdx, foodIdx, field, value) => {
    const updated = { ...editablePlan };
    updated.meals[mealIdx].foods[foodIdx][field] = value;
    setEditablePlan(updated);
  };

  const handleNutritionChange = (mealIdx, foodIdx, field, value) => {
    const updated = { ...editablePlan };
    if (!updated.meals[mealIdx].foods[foodIdx].nutrition) {
      updated.meals[mealIdx].foods[foodIdx].nutrition = {};
    }
    updated.meals[mealIdx].foods[foodIdx].nutrition[field] = value;
    setEditablePlan(updated);
  };
  const handleFodMapChange = (mealIdx, foodIdx, field, value) => {
    const updated = { ...editablePlan };
    if (!updated.meals[mealIdx].foods[foodIdx].fod_map) {
      updated.meals[mealIdx].foods[foodIdx].fod_map = {};
    }
    updated.meals[mealIdx].foods[foodIdx].fod_map.value = value;
    setEditablePlan(updated);
  };

  const handleQuantityChange = (mealIdx, foodIdx, subfield, value) => {
    const updated = { ...editablePlan };
    if (!updated.meals[mealIdx].foods[foodIdx].quantity) {
      updated.meals[mealIdx].foods[foodIdx].quantity = {};
    }
    updated.meals[mealIdx].foods[foodIdx].quantity[subfield] = value;
    setEditablePlan(updated);
  };
  const token = localStorage.getItem("token");
  const handleSave = async () => {
    setLoading(true);
    try {
      console.log('Saving meal plan with data:', editablePlan.meals);
      
      const res = await put(
        `/api/app/diet/mealPlanUpdateAdmin/${planId}/day/${editablePlan.day}`,
        { meals: editablePlan.meals },
      );
      const data = res.data;
      
      console.log('Save response:', data);
      
      toastMessage("Meal plan updated successfully!", "success");
      if (onUpdate) onUpdate(data.data || data); // Use data.data if it exists, otherwise use data
    } catch (err) {
      console.error("Error updating meal plan:", err);
      toastMessage("Server error. Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  };
 const handleAlternativeSelect = (alternative) => {
  const updated = { ...editablePlan };
  const currentFood = updated.meals[selectedMealIdx].foods[selectedFoodIdx];

  updated.meals[selectedMealIdx].foods[selectedFoodIdx] = {
    ...currentFood, // keep coreCategory, etc.
    ...alternative,
  };

  setEditablePlan(updated);
  setSelectedFood(null);
};

const handleAddFood = (mealIdx) => {
  const updated = { ...editablePlan };
  const newFood = {
    name: "",
    coreCategory: "vegetables", // Default category
    category: "vegetables", // Default category
    subCategory: "",
    quantity: { value: "", unit: "" },
    nutrition: { calories: "", protein: "", carbs: "", fiber: "", fat: "" },
    fod_map: { value: "Low" }
  };
  
  updated.meals[mealIdx].foods.push(newFood);
  setEditablePlan(updated);
};

const handleRemoveFood = (mealIdx, foodIdx) => {
  const updated = { ...editablePlan };
  updated.meals[mealIdx].foods.splice(foodIdx, 1);
  setEditablePlan(updated);
};


  return (
    <div>
      <Paper variant="outlined" sx={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Meal Type</TableCell>
              <TableCell>Food</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Calories</TableCell>
              <TableCell>Protein (g)</TableCell>
              <TableCell>Carbs (g)</TableCell>
              <TableCell>Fibre </TableCell>
              <TableCell>Fat </TableCell>
              <TableCell>Fod Map </TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {editablePlan.meals?.map((meal, mealIdx) => (
              <Fragment key={mealIdx}>
                {meal.foods?.map((food, foodIdx) => (
                  <TableRow key={`${mealIdx}-${foodIdx}`}>
                    <TableCell>{meal.type?.toUpperCase() || 'Unknown'}</TableCell>
                    <TableCell
                      onClick={async () => {
                        setSelectedMealIdx(mealIdx);
                        setSelectedFoodIdx(foodIdx);

                        const alternatives = await fetchAlternatives(meal.type || 'breakfast', food.coreCategory);

                        setSelectedFood({
                          ...food,
                          alternatives,
                        });
                      }}
                      sx={{ cursor: "pointer" }}
                    >
                      <TextField
                        variant="standard"
                        value={food.name}
                        onChange={(e) => handleChange(mealIdx, foodIdx, "name", e.target.value)}
                        sx={{ width: 100, mr: 1 }}
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        variant="standard"
                        size="small"
                        value={food.quantity?.value || ""}
                        onChange={(e) =>
                          handleQuantityChange(mealIdx, foodIdx, "value", e.target.value)
                        }
                        sx={{ width: 50, mr: 1 }}
                      />
                      <TextField
                        variant="standard"
                        size="small"
                        value={food.quantity?.unit || ""}
                        onChange={(e) =>
                          handleQuantityChange(mealIdx, foodIdx, "unit", e.target.value)
                        }
                        sx={{ width: 50 }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        type="number"
                        value={food.nutrition?.calories || ""}
                        onChange={(e) =>
                          handleNutritionChange(mealIdx, foodIdx, "calories", e.target.value)
                        }
                        sx={{ width: 50 }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        type="number"
                        value={food.nutrition?.protein || ""}
                        onChange={(e) =>
                          handleNutritionChange(mealIdx, foodIdx, "protein", e.target.value)
                        }
                        sx={{ width: 50 }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        type="number"
                        value={food.nutrition?.carbs || ""}
                        onChange={(e) =>
                          handleNutritionChange(mealIdx, foodIdx, "carbs", e.target.value)
                        }
                        sx={{ width: 50 }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        type="number"
                        value={food.nutrition?.fiber || ""}
                        onChange={(e) =>
                          handleNutritionChange(mealIdx, foodIdx, "fiber", e.target.value)
                        }
                        sx={{ width: 50 }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        type="number"
                        value={food.nutrition?.fat || ""}
                        onChange={(e) =>
                          handleNutritionChange(mealIdx, foodIdx, "fat", e.target.value)
                        }
                        sx={{ width: 50 }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        select
                        variant="standard"
                        size="small"
                        value={food.fod_map?.value || "Low"}
                        onChange={(e) =>
                          handleFodMapChange(mealIdx, foodIdx, "value", e.target.value)
                        }
                        sx={{ width: 80 }}
                      >
                        <MenuItem value="Low">Low</MenuItem>
                        <MenuItem value="Moderate">Moderate</MenuItem>
                        <MenuItem value="High">High</MenuItem>
                        <MenuItem value="-">-</MenuItem>
                      </TextField>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleRemoveFood(mealIdx, foodIdx)}
                        disabled={meal.foods?.length <= 1}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={10}>
                    <Button
                      startIcon={<AddIcon />}
                      onClick={() => handleAddFood(mealIdx)}
                      variant="outlined"
                      size="small"
                      sx={{ mt: 1 }}
                    >
                      Add Food to {meal.type?.toUpperCase() || 'Unknown'}
                    </Button>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <Button
        variant="contained"
        onClick={handleSave}
        sx={{ mt: 2, float: "right" }}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save Changes"}
      </Button>
      <Dialog open={!!selectedFood} onClose={() => setSelectedFood(null)} maxWidth="xs" fullWidth>
  <DialogTitle>Select an Alternative</DialogTitle>
  <DialogContent dividers>
    {selectedFood?.alternatives?.map((alt, idx) => (
      <Button
        key={idx}
        fullWidth
        sx={{ justifyContent: "flex-start", mb: 1 }}
        onClick={() => handleAlternativeSelect(alt)}
        variant="outlined"
      >
        {alt.name}
      </Button>
    ))}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setSelectedFood(null)}>Cancel</Button>
  </DialogActions>
</Dialog>

    </div>
  );
}
